<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Contact Us
            </h1>
        </div>
        <img src="../../../static/images/leicester-map.png" alt="" width="100%" />
        <div class="grid-container pad-top">
            <div class="grid-x grid-padding-x pad-top pad-bottom">
                <div class="cell small-12 medium-6">
                    <ul class="contact-list">
                        <li class="mail">Mail</li>
                        <li class="phone">Call</li>
                        <li class="online">Online Support</li>
                    </ul>
                    <p class="clear pad-top">
                        <strong>Address:</strong><br />
                        Customised Clothing, 53 Bedford Street South, Leicester, LE1 3JR
                    </p>
                    <p>
                        <strong>Phone:</strong><br />
                        +44(0)116 467 0260
                    </p>
                    <p>
                        <strong>Mail:</strong><br />
                        sales@customisedclothing.com
                    </p>
                </div>
                <div class="cell small-12 medium-6">
                    <form v-on:submit="sendForm">
                        <label>Name Surname</label>
                        <input v-model="contact.name" required type="text">
                        <label>Email</label>
                        <input v-model="contact.email" required type="email">
                        <label>Telephone</label>
                        <input v-model="contact.telephone" required type="text">
                        <label>Message</label>
                        <textarea rows="6" v-model="contact.message"></textarea>
                        <button class="button">Send Message</button>
                    </form>
                </div>

            </div>
        </div>

        <div class="bg--img wash heavy bg--home-stats">
            <div class="grid-x grid-padding-x z-up pad-top pad-bottom">
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/product-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of products</p>
                    <h4 class="text-white text-center">4,455</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/customisation-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of customisations to date</p>
                    <h4 class="text-white text-center">23,443</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/satisfaction-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Satisfaction rate</p>
                    <h4 class="text-white text-center">96%</h4>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say</h5>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'Contact',
    metaInfo() {
        return {
            title: 'Contact Us ',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Want customised clothing that\'s tailored to you? Our team can make your unique designs a reality. Let us create your unique style. Reach out now!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/delivery' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                telephone: '',
                message: '',
            },
        };
    },
    methods: {
        sendForm(event) {
            event.preventDefault();
            axios.post('/Contacts/addContact.json', this.contact)
                .then(() => {
                    this.$router.push('/contact-thankyou');
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Contact/Contact.vue